import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '../views/home/HomePage'
import EventsPage from '../views/event/EventsPage'
import EventPage from '../views/event/EventPage'
import NotFoundPage from '../views/pages/NotFoundPage'
import ErrorPage from '../views/pages/ErrorPage'
import MessagePage from '../views/message/MessagePage'
import ViewInfo from '../views/home/ViewInfo'
import EventRemovePage from '../views/event/EventRemovePage'

import { store } from '../_store'

Vue.use(Router)

export const router = new Router({
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', component: HomePage, name: 'hp' },
    { path: '/eventi/:tag', component: EventsPage, name: 'eventi' },
    { path: '/evento/:slug', component: EventPage },
    {
      path: '/prenotazione/conferma/:id', name: 'confermaprenotazione'
    },
    {
      path: '/prenotazione/annulla/:id', name: 'annullaprenotazione'
    },
    {
      path: '/richiesta-annullamento-prenotazione',
      name: 'richiestaannullamento',
      component: EventRemovePage
    },

    { path: '/404', component: NotFoundPage },
    { path: '/500', component: ErrorPage },
    { path: '/messaggio', component: MessagePage },

    { path: '/info', component: ViewInfo },

    // otherwise redirect to home

    { path: '*', redirect: '/404' }
  ]
})

router.beforeEach((to, from, next) => {
  switch (to.name) {
    case 'confermaprenotazione':
      store.dispatch('event/confirmEnrollment', to.params.id)
      break
    case 'annullaprenotazione':
      store.dispatch('event/removeEnrollment', to.params.id)
      break
    case 'eventi':
      store.dispatch('event/clearEvents')
      break
  }

  next()
})
